import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import tz from "dayjs/plugin/timezone";

import { DEFAULT_DATE_FORMAT } from "@constants";

dayjs.extend(utc);
dayjs.extend(tz);

export const formatDateUtc = (
  date: string | Date,
  format: string = DEFAULT_DATE_FORMAT,
): string => {
  const localTz = dayjs.tz.guess();

  return dayjs.utc(date).tz(localTz).format(format);
};
